import { createContext, useContext } from 'react';
import type { SystemSettings } from './appearance';
import type { ColorScheme } from './palette';

export interface ResolvedAppearance {
  /** The OS colour scheme and motion setting, kept current. */
  system: SystemSettings;
  /** The colour scheme in use (System resolved). */
  scheme: ColorScheme;
  reducedMotion: boolean;
}

export const AppearanceContext = createContext<ResolvedAppearance>({
  system: { prefersDark: false, prefersReducedMotion: false },
  scheme: 'light',
  reducedMotion: false,
});

/** The appearance AppearanceRoot resolved (light/dark, OS settings). */
export const useAppearance = () => useContext(AppearanceContext);
